import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOfferHistory, setPage, setRoomsFilter, setStatusFilter } from '../../../../store/offerHistory/actions';
import { THandleStatusFiltersClick } from '../../components/types';
import { STATUS_ALL } from '../../../../store/offerHistory';
import { selectOfferId } from '../../../../selectors/offerData/offer';
import { trackOfferFilterSelect } from '../analytics';

/**
 * Хендлер клика по фильтру статусов
 * */
export const useHandleStatusFiltersClick = (): THandleStatusFiltersClick => {
  const dispatch = useDispatch();
  const offerId = useSelector(selectOfferId);

  return React.useCallback(
    id => {
      dispatch(setRoomsFilter(null));

      /**
       * Фильтр "All" мы не устанавливаем в стор, он не должен отправляться в апи
       * */
      dispatch(setStatusFilter(id === STATUS_ALL ? null : [id]));

      dispatch(setPage(1));
      dispatch(getOfferHistory(false));

      trackOfferFilterSelect(offerId, id);
    },
    [dispatch, offerId],
  );
};
